import { apiFetch } from '@/api/client'

/** Lab BettickerMapping doubtful + watchlist lists (Agent — no Smart Members). */
export type BettickerMapping = {
  mappedDoubtfullUsers: string[]
  mappedDoubtfullIps: string[]
  mappedWatchlistUsers: string[]
  mappedWatchlistIps: string[]
}

type StandardEnvelope = {
  status?: number
  message?: string
  data?: unknown
}

function listOrEmpty(x: unknown): string[] {
  return Array.isArray(x) ? (x as string[]) : []
}

function parseBettickerMapping(v: unknown): BettickerMapping | null {
  if (!v || typeof v !== 'object') return null
  const o = v as Record<string, unknown>
  // Accept full Lab/CM five-list payload or Agent four-list (smart optional).
  if (
    !Array.isArray(o.mappedDoubtfullUsers) &&
    !Array.isArray(o.mappedDoubtfullIps) &&
    !Array.isArray(o.mappedWatchlistUsers) &&
    !Array.isArray(o.mappedWatchlistIps) &&
    !Array.isArray(o.mappedSmartUsers)
  ) {
    return null
  }
  return {
    mappedDoubtfullUsers: listOrEmpty(o.mappedDoubtfullUsers),
    mappedDoubtfullIps: listOrEmpty(o.mappedDoubtfullIps),
    mappedWatchlistUsers: listOrEmpty(o.mappedWatchlistUsers),
    mappedWatchlistIps: listOrEmpty(o.mappedWatchlistIps),
  }
}

function unwrapMapping(res: unknown, fallback: string): BettickerMapping {
  let cur: unknown = res
  for (let i = 0; i < 4; i++) {
    const parsed = parseBettickerMapping(cur)
    if (parsed) return parsed
    if (!cur || typeof cur !== 'object' || !('data' in cur)) break
    cur = (cur as StandardEnvelope).data
  }
  const msg =
    res &&
    typeof res === 'object' &&
    typeof (res as StandardEnvelope).message === 'string'
      ? (res as StandardEnvelope).message!
      : fallback
  throw new Error(msg || fallback)
}

/** Lab `BettickerMapping/getBettickerMapping` → hierarchy `POST /v1/book/getBettickerMapping`. */
export async function getBettickerMapping(): Promise<BettickerMapping> {
  const res = await apiFetch<unknown>('/v1/book/getBettickerMapping', {
    method: 'POST',
    body: JSON.stringify({}),
  })
  return unwrapMapping(res, 'Invalid getBettickerMapping response')
}

/** Lab `BettickerMapping/updateBettickerMapping`. */
export async function updateBettickerMapping(body: {
  mappedDoubtfullUsers?: string[]
  mappedDoubtfullIps?: string[]
  mappedWatchlistUsers?: string[]
  mappedWatchlistIps?: string[]
}): Promise<BettickerMapping> {
  const res = await apiFetch<unknown>('/v1/book/updateBettickerMapping', {
    method: 'POST',
    body: JSON.stringify(body),
  })
  return unwrapMapping(res, 'Invalid updateBettickerMapping response')
}
